export const AD_CREATED = 'AD_CREATED';
export const CREATE_AD_FAILED = 'CREATE_AD_FAILED';

export const UPDATE_FIELDS = 'UPDATE_FIELDS';
export const RESET_FIELDS = 'RESET_FIELDS';
export const POPULATE_FIELDS = 'POPULATE_FIELDS';

export const STORE_AD = 'STORE_AD';
export const LOAD_AD = 'LOAD_AD';
export const RESTORE_AD = 'RESTORE_AD';
export const CLEAR_SAVED_AD = 'CLEAR_SAVED_AD';

export const RESET_CREATE_AD = 'RESET_CREATE_AD';

export function resetFields() {
  return {
    type: RESET_FIELDS,
  };
}

export function updateFields(field, groups = {}) {
  return {
    type: UPDATE_FIELDS,
    field,
    groups,
  };
}

export function adCreated(ad) {
  return {
    type: AD_CREATED,
    name: ad.name,
  };
}

export function createAdFailed(err) {
  return {
    type: CREATE_AD_FAILED,
    err,
  };
}

export function populateFields(state) {
  return {
    type: POPULATE_FIELDS,
    state,
  };
}

export function storeAd() {
  return {
    type: STORE_AD,
  };
}

export function clearSavedAd() {
  return {
    type: CLEAR_SAVED_AD,
  };
}

export function restoreAd() {
  return {
    type: RESTORE_AD,
  };
}

export function loadAd(ad) {
  return {
    type: LOAD_AD,
    payload: ad,
  };
}

export function resetCreateAd() {
  return {
    type: RESET_CREATE_AD,
  };
}



// WEBPACK FOOTER //
// ./src/actions/editable-ad.js